import { FC } from 'react'
import { Box, PageTitle } from '@perk-ui/core'

import { useSitesContext } from '../../components/SitesProvider'
import TableauView from '../../components/TableauView'
import { useUser } from '../../features/auth/AuthContext'

export interface RawDataProps {}

// const useStyles = makeStyles((theme) => ({

// }))

const RawData: FC<RawDataProps> = () => {
  const sitesContext = useSitesContext()
  const currentUser = useUser()
  const site = sitesContext.currentSite
  const staffTableauSubscription = currentUser?.staff.subscriptionPlan

  const pageTitle = 'Raw Data'

  if (!site) return null

  const getWorkbookUrl = () => {
    switch (staffTableauSubscription) {
      case 'performance_rsx_ebm':
      case 'performance_rsx_registry':
      case 'performance_rsx_ebm_registry':
      case 'performance_rsx':
        return 'views/raw_data_premium/PremiumRawDataSummary'
      case 'performance':
      case 'performance_registry':
      case 'performance_ebm_registry':
      case 'performance_ebm':
      case 'starter':
      case 'demo':
      case 'essentials':
      default:
        return ''
    }
  }

  const rawDataTableauParameters = [
    {
      key: 'parameter_select_subscription_type',
      value: 'IMPACT',
    },
    // {
    //   key: 'parameter_select_site_id',
    //   value: site?.id,
    // },
    // {
    //   key: 'parameter_select_provider_id',
    //   value: currentUser?.staff?.id,
    // },
  ]

  return (
    <Box p={3}>
      <PageTitle title={pageTitle} />
      {getWorkbookUrl() !== '' && (
        <TableauView
          src={getWorkbookUrl()}
          toolbar="top"
          hideTabs={false}
          parameters={rawDataTableauParameters}
          section="raw-data"
        />
      )}
    </Box>
  )
}

export default RawData
